var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "StatusDisplayBar" },
    [
      _c(
        "v-alert",
        {
          staticClass: "status-alert",
          attrs: { value: _vm.hasError, type: "error" }
        },
        [
          typeof _vm.error === "string"
            ? _c("span", [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")])
            : _c(
                "ul",
                {
                  class:
                    _vm.error && _vm.error.length == 1 ? "list-style-none" : ""
                },
                _vm._l(_vm.error, function(err, errIndex) {
                  return _c("li", { key: errIndex }, [
                    _vm._v("\n        " + _vm._s(err) + "\n      ")
                  ])
                }),
                0
              )
        ]
      ),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          staticClass: "status-alert",
          attrs: { value: _vm.hasWarning, type: "warning" }
        },
        [
          typeof _vm.warnMessage === "string"
            ? _c("span", [
                _vm._v("\n      " + _vm._s(_vm.warnMessage) + "\n    ")
              ])
            : _c(
                "ul",
                _vm._l(_vm.warnMessage, function(warn, warnIndex) {
                  return _c("li", { key: warnIndex }, [
                    _vm._v("\n        " + _vm._s(warn) + "\n      ")
                  ])
                }),
                0
              )
        ]
      ),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          staticClass: "status-alert",
          attrs: { value: _vm.hasWarningData, type: "warning" }
        },
        [
          _c("span", [_vm._v("\n      " + _vm._s(_vm.warningText) + "\n    ")]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.warningData, function(warn, warnDataIndex) {
              return _c("li", { key: warnDataIndex }, [
                _vm._v("\n        " + _vm._s(warn) + "\n      ")
              ])
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          staticClass: "status-alert",
          attrs: { value: _vm.hasSuccess, type: "success" }
        },
        [
          _vm._t("SuccessMessage", [
            _vm._v("\n      " + _vm._s(_vm.successMessage) + "\n    ")
          ])
        ],
        2
      ),
      _vm._v(" "),
      _vm.hasLoadMessage
        ? _c(
            "v-alert",
            {
              staticClass: "status-alert",
              attrs: { value: _vm.loading, type: "info" }
            },
            [_vm._v("\n    " + _vm._s(_vm.loadingMessage) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c("v-progress-linear", {
            attrs: { indeterminate: "", color: "success" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }